import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'subcGroupOrder',
})
export class SubcGroupOrderPipe implements PipeTransform {
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
    transform(value: any[], args?: any): any {
        const index = value?.findIndex(el => el.key == 'Neaktivni');
        if (index > -1) {
            value.push(value.splice(index, 1)[0]);
        }
        return value;
    }
}
